import React from 'react';

import Button from 'js/src/components/common/ui/Button';

type Props = {
    onClick: () => void;
};
const FinishRecordingButton: React.FC<Props> = ({ onClick }) => {
    return <Button text="Finish recording" iconLeft="done" onClick={onClick} />;
};
export default React.memo(FinishRecordingButton);
